<script>
import { listQuickNav, getQuickNavMenuTree, saveQuickNav } from "@/api/wms/quickNav";

export default {
  name: "QuickNav",
  data() {
    return {
      // 当前用户的快捷导航项（后端按 user_id + 权限过滤并拼好完整路由 path）
      items: [],
      // 配置弹窗
      dialogVisible: false,
      saving: false,
      menuTree: [],
      // 弹窗中已选列表：{menuId, name, icon(覆盖值，空为跟随菜单), menuIcon}
      checkedItems: [],
      defaultProps: {
        label: "label",
        children: "children",
        disabled: "disabled"
      },
      iconOptions: [
        { value: "", label: "跟随菜单图标" },
        { value: "el-icon-s-home", label: "首页" },
        { value: "el-icon-s-order", label: "订单" },
        { value: "el-icon-s-goods", label: "商品" },
        { value: "el-icon-box", label: "箱子" },
        { value: "el-icon-truck", label: "物流" },
        { value: "el-icon-ship", label: "海运" },
        { value: "el-icon-receiving", label: "收货" },
        { value: "el-icon-tickets", label: "单据" },
        { value: "el-icon-s-management", label: "管理" },
        { value: "el-icon-s-data", label: "数据" },
        { value: "el-icon-s-finance", label: "财务" },
        { value: "el-icon-money", label: "费用" },
        { value: "el-icon-s-check", label: "审核" },
        { value: "el-icon-s-claim", label: "申请" },
        { value: "el-icon-s-marketing", label: "营销" },
        { value: "el-icon-s-shop", label: "店铺" },
        { value: "el-icon-s-custom", label: "客户" },
        { value: "el-icon-s-operation", label: "操作" },
        { value: "el-icon-s-promotion", label: "推广" },
        { value: "el-icon-printer", label: "打印" },
        { value: "el-icon-document", label: "文档" },
        { value: "el-icon-folder", label: "目录" },
        { value: "el-icon-star-on", label: "星标" },
        { value: "el-icon-time", label: "时间" },
        { value: "el-icon-setting", label: "设置" },
        { value: "el-icon-location-outline", label: "库位" },
        { value: "el-icon-guide", label: "引导" },
        { value: "el-icon-s-tools", label: "工具" },
        { value: "el-icon-menu", label: "菜单" }
      ]
    };
  },
  methods: {
    // 拉取当前用户的快捷导航
    fetchQuickNav() {
      listQuickNav().then(res => {
        this.items = res.data || [];
      }).catch(() => {
        // 加载失败时导航项清空，不影响配置入口
        this.items = [];
      });
    },
    // 点击导航项直接跳转
    handleNavClick(item) {
      if (!item.path) return;
      this.$router.push(item.path);
    },
    // 导航标志：仅 Element 图标类（el-icon-*）才可直接当 class 使用；
    // 菜单自身 icon 是侧边栏 svg 体系的名称（如 default、table），落到 <i class> 上什么都不显示，
    // 因此未配置或不可用时统一兜底为星标
    resolveNavIcon(icon) {
      return icon && String(icon).indexOf('el-icon-') === 0 ? icon : 'el-icon-star-on';
    },
    // 滚轮横向滚动：条数不设上限，超出 max-width 后靠滑动查看
    handleNavWheel(e) {
      const el = this.$refs.navItems;
      if (!el) return;
      el.scrollLeft += (e.deltaY || e.deltaX);
    },
    // 打开配置弹窗（顶栏按钮直接进配置，不再经过导航面板）
    openConfig() {
      getQuickNavMenuTree().then(res => {
        this.menuTree = res.data || [];
        this.checkedItems = this.items.map(it => ({
          menuId: it.menuId,
          name: it.menuName,
          icon: it.icon && it.icon !== it.menuIcon ? it.icon : "",
          menuIcon: it.menuIcon || ""
        }));
        this.dialogVisible = true;
        this.$nextTick(() => {
          if (this.$refs.menuTree) {
            this.$refs.menuTree.setCheckedKeys(this.checkedItems.map(it => it.menuId));
          }
        });
      });
    },
    // 树勾选变化：同步右侧已选列表（保留已有顺序与图标配置，新勾选的追加到末尾）
    handleTreeCheck() {
      const nodes = this.$refs.menuTree.getCheckedNodes().filter(n => n.menuType === "C");
      const next = [];
      this.checkedItems.forEach(it => {
        if (nodes.some(n => n.id === it.menuId)) {
          next.push(it);
        }
      });
      nodes.forEach(n => {
        if (!next.some(it => it.menuId === n.id)) {
          // 新勾选项的默认图标：由「跟随菜单图标」改为「星标」。
          // 菜单自身 icon 存的是侧边栏 svg 体系名称（default/table 等），
          // 放到顶栏 <i class> 上根本不渲染，“跟随”实际等于没图标
          next.push({ menuId: n.id, name: n.label, icon: "el-icon-star-on", menuIcon: n.icon || "" });
        }
      });
      this.checkedItems = next;
    },
    moveUp(index) {
      if (index <= 0) return;
      const list = this.checkedItems;
      list.splice(index - 1, 0, list.splice(index, 1)[0]);
    },
    moveDown(index) {
      const list = this.checkedItems;
      if (index >= list.length - 1) return;
      list.splice(index + 1, 0, list.splice(index, 1)[0]);
    },
    removeItem(index) {
      const removed = this.checkedItems.splice(index, 1)[0];
      if (removed && this.$refs.menuTree) {
        this.$refs.menuTree.setChecked(removed.menuId, false, false);
      }
    },
    // 保存当前用户的配置（整体替换，只影响自己）
    submitConfig() {
      const payload = this.checkedItems.map((it, idx) => ({
        menuId: it.menuId,
        icon: it.icon || null,
        orderNum: idx
      }));
      this.saving = true;
      saveQuickNav(payload).then(() => {
        // 时长收紧到 0.7 秒：默认 3 秒容易让人觉得提示卡住了
        this.$message({ type: "success", message: "快速导航保存成功", duration: 700 });
        this.dialogVisible = false;
        this.fetchQuickNav();
      }).catch(() => {}).finally(() => {
        this.saving = false;
      });
    }
  },
  created() {
    this.fetchQuickNav();
  }
};
</script>

<template>
  <div class="quick-nav">
    <!-- 配置好的导航项排在按钮左侧：右对齐的顶栏簇里，条目增多只会把区域左边界往左推，
         触发按钮、头像、设置按钮的位置恒定不动；条数不设上限，超出 max-width 横向滚动 -->
    <div
      v-if="items.length"
      ref="navItems"
      class="quick-nav-items"
      @wheel.prevent="handleNavWheel">
      <div
        class="quick-nav-item"
        v-for="item in items"
        :key="item.navId"
        :title="item.menuName"
        @click="handleNavClick(item)">
        <i :class="resolveNavIcon(item.icon)"></i>
        <span class="item-text">{{ item.menuName }}</span>
      </div>
    </div>

    <!-- 顶栏触发图标（样式同改造前，点击直接进配置弹窗） -->
    <div class="quick-nav-trigger" title="配置快速导航" @click="openConfig">
      <i class="el-icon-s-grid"></i>
    </div>

    <!-- 配置弹窗 -->
    <el-dialog title="配置快速导航" :visible.sync="dialogVisible" width="900px" append-to-body>
      <div class="config-wrapper">
        <div class="config-left">
          <p class="config-tip">勾选要加入快速导航的菜单（仅你有权限的菜单，目录用于分组展开）</p>
          <div class="tree-box">
            <el-tree
              ref="menuTree"
              :data="menuTree"
              show-checkbox
              check-strictly
              node-key="id"
              :props="defaultProps"
              :expand-on-click-node="false"
              empty-text="暂无可配置的菜单，请联系管理员开通菜单权限"
              @check="handleTreeCheck">
            </el-tree>
          </div>
        </div>
        <div class="config-right">
          <p class="config-tip">已选 {{ checkedItems.length }} 项，可调整顺序与图标</p>
          <div class="selected-box">
            <div class="selected-item" v-for="(item, index) in checkedItems" :key="item.menuId">
              <span class="item-index">{{ index + 1 }}</span>
              <i class="item-icon" :class="resolveNavIcon(item.icon || item.menuIcon)"></i>
              <span class="item-name" :title="item.name">{{ item.name }}</span>
              <el-select v-model="item.icon" size="mini" class="item-icon-select" placeholder="图标">
                <el-option
                  v-for="opt in iconOptions"
                  :key="opt.value"
                  :label="opt.label"
                  :value="opt.value">
                  <i v-if="opt.value" :class="opt.value" style="margin-right: 6px;"></i>
                  <span>{{ opt.label }}</span>
                </el-option>
              </el-select>
              <span class="item-ops">
                <el-button type="text" size="mini" icon="el-icon-top" :disabled="index === 0" @click="moveUp(index)"></el-button>
                <el-button type="text" size="mini" icon="el-icon-bottom" :disabled="index === checkedItems.length - 1" @click="moveDown(index)"></el-button>
                <el-button type="text" size="mini" icon="el-icon-delete" class="delete-btn" @click="removeItem(index)"></el-button>
              </span>
            </div>
            <div v-if="!checkedItems.length" class="selected-empty">请在左侧勾选菜单</div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" class="button-search" :loading="saving" @click="submitConfig">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<style scoped>
/* 组件根：导航项 + 按钮横向排开，撑满顶栏高度保证悬停背景完整。
   外层布局类见 Navbar 的 .quick-nav-slot（inline-flex），此处同值兜底 */
.quick-nav {
  display: inline-flex;
  align-items: stretch;
  height: 100%;
}

/* 顶栏触发图标：padding/悬停效果对齐原 right-menu-item hover-effect 观感 */
.quick-nav-trigger {
  display: flex;
  align-items: center;
  padding: 0 8px;
  cursor: pointer;
  transition: background .3s;
}

.quick-nav-trigger:hover {
  background: var(--theme-menu-hover-bg);
  color: var(--theme-primary);
}

.quick-nav-trigger i {
  font-size: 18px;
  vertical-align: middle;
}

/* 导航项区：宽度随条目自然增长（上限 65vw，再往左让出面包屑区的空间），
   溢出时区内横向滚动（滚轮也可横滚），条目从左往右依次排开 */
.quick-nav-items {
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 65vw;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: thin;
  padding: 0 20px 0 5px;
}

.quick-nav-items::-webkit-scrollbar {
  height: 4px;
}

.quick-nav-items::-webkit-scrollbar-thumb {
  background: #c0c4cc;
  border-radius: 2px;
}

/* 单个导航项：系统主题色+加粗；每项加边框成盒。
   line-height 必须显式收紧：外层 .right-menu 是 line-height:50px，
   继承下来会让盒子比顶栏还高、上下边框被裁掉 */
.quick-nav-item {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  padding: 3px 10px;
  line-height: 24px;
  border: 1px solid var(--theme-primary);
  border-radius: 6px;
  font-size: 13px;
  font-weight: bold;
  color: var(--theme-primary);
  cursor: pointer;
  white-space: nowrap;
  transition: background .3s;
}

.quick-nav-item:hover {
  background: var(--theme-menu-hover-bg);
}

.quick-nav-item i {
  font-size: 15px;
}

.item-text {
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 配置弹窗 */
.config-wrapper {
  display: flex;
  gap: 16px;
}

.config-left {
  flex: 1;
  min-width: 0;
}

.config-right {
  flex: 1.3;
  min-width: 0;
}

.config-tip {
  font-size: 13px;
  color: #909399;
  margin-bottom: 8px;
}

.tree-box {
  height: 400px;
  overflow: auto;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 8px;
}

.selected-box {
  height: 400px;
  overflow: auto;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 4px 8px;
}

.selected-item {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 7px 2px;
  border-bottom: 1px dashed #eeeeee;
}

.item-index {
  width: 20px;
  font-size: 12px;
  color: #909399;
  text-align: center;
  flex-shrink: 0;
}

.item-icon {
  font-size: 18px;
  color: var(--theme-primary);
  flex-shrink: 0;
}

.item-name {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  color: #333333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.item-icon-select {
  width: 130px;
  flex-shrink: 0;
}

.item-ops {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.item-ops .el-button {
  padding: 2px;
  margin-left: 4px;
}

.delete-btn {
  color: #f56c6c;
}

.selected-empty {
  padding: 30px 0;
  text-align: center;
  font-size: 13px;
  color: #909399;
}

.button-search {
  background-color: var(--theme-primary) !important;
  border-color: var(--theme-primary) !important;
  color: #ffffff;
}

.button-search:hover {
  filter: brightness(1.2);
}
</style>
